'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _regLogin = require('@zillow/reg-login');

var _regLogin2 = _interopRequireDefault(_regLogin);

require('@zillow/reg-login/reg-login');

var _constants = require('../../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders the reg/login app.
 **/
function initApp() {
    var loginAnchor = global.window.document.getElementById(_constants.LOGIN_ANCHOR_ID);

    if (loginAnchor) {
        var regDataNode = global.window.document.getElementById(_constants.HIDDEN_REG_ID);
        var config = regDataNode ? JSON.parse(regDataNode.value) : {};

        (0, _reactDom.render)(_react2.default.createElement(_regLogin2.default, config), loginAnchor);
    }
} /*
      This file is webpack'd to work on the browser.
      This is the script that initializes the reg-login modules on the page
      asynchronously
  */


initApp();


//////////////////
// WEBPACK FOOTER
// ./lib/client-assets/scripts/reg.js
// module id = 477
// module chunks = 0